/**
 * Utility functions for handling HTML content from rich text editors
 */

/**
 * Strips HTML tags from a string and returns plain text
 * @param html HTML string to strip
 * @returns Plain text string
 */
function stripHtmlTags(html: string): string {
	if (!html) return '';
	
	// Create a temporary div element to parse the HTML
	const tempDiv = document.createElement('div');
	tempDiv.innerHTML = html;
	
	// Get text content and clean up extra whitespace
	return tempDiv.textContent || tempDiv.innerText || '';
}

/**
 * Truncates HTML content to a specified character limit while preserving some formatting
 * @param html HTML string to truncate
 * @param limit Character limit for the plain text version
 * @returns Truncated plain text
 */
export function truncateHtmlContent(html: string, limit: number = 150): string {
	if (!html) return '';
	
	const plainText = stripHtmlTags(html);
	
	if (plainText.length <= limit) return plainText;
	
	// Find the last space before the limit to avoid cutting words
	const truncated = plainText.substring(0, limit);
	const lastSpaceIndex = truncated.lastIndexOf(' ');
	
	if (lastSpaceIndex > limit * 0.8) {
		return truncated.substring(0, lastSpaceIndex) + '...';
	}
	
	return truncated + '...';
}
